module.exports = __webpack_public_path__ + "img/arrowRight.b88ece3e.svg";